'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultExport = new String('.sponsor{padding:12px 20px;background-color:#f9f9f9;}.text{color:#888;font-size:12px;padding-right:20px;font-weight:400;}.logo{height:24px;vertical-align:middle;width:auto;}@media only screen and (min-width:767px){.logo{height:38px;}}');

_defaultExport.__hash = '1014306418';
_defaultExport.__scoped = '.sponsor.jsx-1602034227{padding:12px 20px;background-color:#f9f9f9;}.text.jsx-1602034227{color:#888;font-size:12px;padding-right:20px;font-weight:400;}.logo.jsx-1602034227{height:24px;vertical-align:middle;width:auto;}@media only screen and (min-width:767px){.logo.jsx-1602034227{height:38px;}}';
_defaultExport.__scopedHash = '1602034227';
exports.default = _defaultExport;